// extracted by mini-css-extract-plugin
module.exports = {"title":"WidgetAdder_title__LRY05","root":"WidgetAdder_root__2mCa-","foreground":"WidgetAdder_foreground__1l7Pj","addLabel":"WidgetAdder_addLabel__GrsfU"};